/**
 * Персональная интеграция Tenderplan (API-ключ пользователя).
 */

export async function getTenderplanIntegration(api) {
  const { data } = await api.get('/integrations/tenderplan/')
  return data
}

export async function connectTenderplan(api, apiToken) {
  const { data } = await api.put('/integrations/tenderplan/', { api_token: apiToken })
  return data
}

export async function disconnectTenderplan(api) {
  const { data } = await api.delete('/integrations/tenderplan/')
  return data
}

export function integrationErrorMessage(err) {
  const code = err?.response?.data?.code
  const detail = err?.response?.data?.detail
  if (detail) return detail
  if (code === 'invalid_api_key') return 'Неверный API-ключ.'
  if (code === 'service_unavailable') return 'Сервис поиска временно недоступен.'
  return 'Не удалось выполнить операцию.'
}
